type TBranchLeaveGuard = () => Promise<boolean>;
const guards = new Set<TBranchLeaveGuard>();
let revision = 0;

/** Branch selectors run before selectedBranch changes and clears the draft. */
export function registerReservationBranchLeave(guard: TBranchLeaveGuard) {
  guards.add(guard);
  revision++;
  let registered = true;
  return () => {
    if (!registered) return;
    registered = false;
    guards.delete(guard);
    revision++;
  };
}

export async function confirmReservationBranchLeave(): Promise<boolean> {
  const current = revision;
  try {
    for (const guard of guards) {
      if (!(await guard()) || current !== revision) return false;
    }
    return current === revision;
  } catch {
    return false;
  }
}
